export default __webpack_public_path__ + "static/media/Peer_Ratings_Data_Template.9445cf3a.xlsx";